import React, { useState, useEffect } from "react";
import closeSvg from "../../assets/images/uncheck.svg";
import PreviewFrameEdit from "../PreviewFrameEdit";
import {
  SlIcon,
  SlInput,
  SlOption,
  SlSelect,
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import { useNavigate } from "react-router";
import api from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import {
  appCategoryNames,
  BrandsTypes as BrandsTypesOriginal,
  formatSpentValue,
  genderNames,
  langNames,
  languageOptions,
  osNames,
  slotOptions,
  slotPositions,
} from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import ScrollContainer from "react-indiana-drag-scroll";
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
const year = yesterday.getFullYear();
const month = String(yesterday.getMonth() + 1).padStart(2, "0"); // Months are zero-based
const day = String(yesterday.getDate()).padStart(2, "0");
const BrandsTypes = [...BrandsTypesOriginal]

const formattedDate = `${year}-${month}-${day}`;
export const InventoryContext = React.createContext();
function Inventory() {
  const [dateFilter, setDateFilter] = useState(formattedDate);
  const [initialRender, setInitialRender] = useState(true);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [adsdata, setAdsData] = useState([]);
  const [netPosView, setNetPosView] = useState(null);
  const [showAdPositions, setShowAdPositions] = useState(false);
  const [languages, setLanguauges] = useState(["tel", "tam", "other"]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(1);
  const [selectedDistrict, setselectedDistrict] = useState(-1);
  const [preview, setPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(-1);
  const [errorCodewiseStats, setErrorCodewiseStats] = useState(null);
  const [missingUsersCounts, setMissingUsersCounts] = useState(null);
  const [isMissingUsersCountsLoader, setIsMissingUsersCountsLoader] = useState(false);
  const [dfpInternalData, setDFPInternalData] = useState([])
  const navigate = useNavigate();
  const getdata = async () => {
    setLoader(true);
    try {
      let res = await api({
        url: "/inventory/get-data",
        method: "POST",
        responseType: "json",
        data: {
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setData(res?.data);
        setFilteredData(res?.data);
      } else {
        // if (res.data.code === 400)
        //   Toast("error", `Please Select Date On or Below ${formattedDate} `);
        // else
         Toast("error", res.data?.message);
        setData([]);
      }
      setLoader(false);
      setInitialRender(false);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const fetchPreview = async (data) => {
    try {
      let res = await api({
        url: "/inventory/get-preview",
        method: "POST",
        responseType: "json",
        data: {
          campaign_id: data.campaign_id,
        },
      });
      if (res.code === 200) {
        setPreview(res?.data);
        setShowPreview(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getdata();
    getMissingUserCounts();
  }, []);
  useEffect(() => {
    setShowAdPositions(false);
    setErrorCodewiseStats(null);
    setNetPosView(null);
    setMissingUsersCounts(null);
    if (!initialRender){
      getdata();
      getMissingUserCounts();
    }
  }, [dateFilter, selectedLanguage, selectedDistrict]);

  const fetchAdsData = async (body) => {
    try {
      let res = await api({
        url: "/inventory/get-team-campaigns-data",
        method: "POST",
        responseType: "json",
        data: {
          ...body,
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setAdsData(res?.data);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const fetchDFPInternalData = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-dfp-internal-data",
        method: "POST",
        responseType: "json",
        data: {...body, date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (res.code === 200) {
        setDFPInternalData(res?.data);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error("Error @ fetchDFPInternalData", error);
    }    
  }

  const getNetadcodeWiseStats = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-netadcode-stats",
        method: "POST",
        responseType: "json",
        data: {...body, 
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setNetPosView({lang_id: selectedLanguage, position: body.position, ad_type: body.ad_type, data: res?.data});
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error("Error @ getNetadcodeWiseStats", error)
    }
  }

  const getNoFillOtherWiseStats = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-nofillother-stats",
        method: "POST",
        responseType: "json",
        data: {...body, 
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setNetPosView({lang_id: selectedLanguage, position: body.position, ad_type: body.error_type === 'no_fill' ? 'No Fill' : 'Other Errors', data: res?.data});
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error("Error @ getNetadcodeWiseStats", error)
    }
  }

  useEffect(() => {
    if (showAdPositions) {
      const adData = data.filter((item) => {
        return slotPositions.includes(item.position);
      });

      setFilteredData(adData);
    } else {
      if (data.length > 0) {
        setFilteredData(data);
      }
    }
  }, [showAdPositions]);

  const handleLanguage = (e) => {
    let value = e.target.value;
    setselectedDistrict(-1)
    setSelectedLanguage(+value);
  };
  const fetchActualDistrict = async (lang_id) => {
    try {
      let res = await api({
        url: "/location/get-actual-districts",
        method: "POST",
        responseType: "json",
        data: { lang_id },
      });
      if (res.code === 200) {
        setDistrictOptions(res.data);
      }
    } catch (error) {
      console.error("Error @ fetchActualDistrict", error);
    }
  };

  const handleDistrict = (e) => {
    setselectedDistrict(+e.target.value);
  };
  useEffect(() => {
    fetchActualDistrict(selectedLanguage);
  }, [selectedLanguage]);

  const fetchErrorCodewiseStats = async (body) => {
    try {
      let data = await api({
        url: "/inventory/get-error-code-wise-stats",
        method: "POST",
        responseType: "json",
        data: {...body, date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (data.code === 200) {
        setErrorCodewiseStats(data.data);
      }
    } catch (error) {
      console.error("Error @ fetchErrorCodewiseStats", error);
    }
  }

  const getMissingUserCounts = async(body) => {
    try {
      setIsMissingUsersCountsLoader(true);
      let data = await api({
        url: "/inventory/get-missing-user-count",
        method: "POST",
        responseType: "json",
        data: {date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (data.code === 200) {
        setMissingUsersCounts(data.data);
      } else {
        console.error("Error @ getMissingusersCount",data.data?.message);
      }
      setIsMissingUsersCountsLoader(false);
    } catch (error) {
      console.error("Error @ getMissingUserCounts", error);
    }
  }



  return (
    <div className="inventory">
     

      {/* Filters Section */}
       <div className="flex items-center gap-3 mt-1 sticky top-0 z-20 w-full">
         <aside className="filters flex gap-2 bg-white mt-0 py-2">
            {/* GAM Stats Section */}
           <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg px-2 py-2 shadow-sm">
             <div className="flex items-center gap-2">
               <div className="flex items-center gap-2">
                 <span className="text-blue-600 font-semibold text-sm">GAM Network {dateFilter}</span>
               </div>
               
               {isMissingUsersCountsLoader ? (
                 <div className="flex items-center gap-4">
                   <div className="bg-blue-200 rounded animate-pulse h-5 w-24"></div>
                   <div className="bg-blue-200 rounded animate-pulse h-5 w-24"></div>
                 </div>
               ) : (
                 <>
                   <div className="flex items-center gap-2">
                     <span className="text-xs text-gray-500">Requests Missing:</span>
                     <div className="flex items-center gap-2">
                       <span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs font-medium" title={missingUsersCounts?.on_block_count || 0}>
                         On : {formatSpentValue(missingUsersCounts?.on_block_count || 0)}
                       </span>
                       <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs font-medium" title={missingUsersCounts?.till_block_count || 0}>
                         Till : {formatSpentValue(missingUsersCounts?.till_block_count || 0)}
                       </span>
                     </div>
                   </div>
                   
                   <div className="flex items-center gap-2">
                     <span className="text-xs text-gray-500">Display Missing:</span>
                     <div className="flex items-center gap-2">
                       <span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs font-medium" title={missingUsersCounts?.on_miss_count || 0}>
                         On : {formatSpentValue(missingUsersCounts?.on_miss_count || 0)}
                       </span>
                       <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs font-medium" title={missingUsersCounts?.till_miss_count || 0}>
                         Till : {formatSpentValue(missingUsersCounts?.till_miss_count || 0)}
                       </span>
                     </div>
                   </div>
                 </>
               )}
             </div>
           </div>
          <SlSelect value={"" + selectedLanguage} onSlChange={handleLanguage}>
            <SlOption value={-1}>All</SlOption>
            {languageOptions.map((item) => {
              return <SlOption value={item.value}>{item.label}</SlOption>;
            })}
          </SlSelect>
          <SlSelect value={"" + selectedDistrict} onSlChange={handleDistrict}>
            <SlOption value={-1}>All</SlOption>
            <SlOption value={0}>Others</SlOption>
            {districtOptions.map((item) => {
              return <SlOption value={item.value}>{item.label}</SlOption>;
            })}
          </SlSelect>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              checked={showAdPositions}
              onChange={() => {
                setShowAdPositions((prev) => !prev);
              }}
              id="showads"
            />
            <label class="form-check-label" for="showads">
              Show Ad Positions
            </label>
          </div>
          <SlInput
            size="medium"
            type="date"
            placeholder="Date"
            onSlInput={(e) => {
              setDateFilter(e.target.value);
            }}
            value={dateFilter}
            max={formattedDate} // Restrict to today
          />
        </aside>
      </div>
        <table
          className="table table-bordered table-impress"
          style={{ width: "100%", margin: "auto" }}
        >
          <thead className="bg-yellow-200 sticky top-[54px] z-10">
            <tr>
              <th rowSpan={3}>Position</th>
              <td colSpan={11 + BrandsTypes.length + 3 - 1}>
                {langNames[selectedLanguage]}
              </td>
            </tr>
            <tr>
              {[
                "Total",
                "Direct Occupied",
                "GAM Occupied",
                "Ad Partners Occupied",
                "Occupency Rate",
              ].map((field, index) => (
                <th
                  rowSpan={
                    field === "Direct Occupied" || field === "GAM Occupied"
                      ? 1
                      : 2
                  }
                  colSpan={
                    field === "Direct Occupied"
                      ? BrandsTypes.length + 4
                      : field === "GAM Occupied"
                      ? 6
                      : 1
                  }
                  key={`${field}-${index}`}
                >
                  {field}
                </th>
              ))}
            </tr>
            <tr>
              <th>Slot</th>
              {BrandsTypes.map((brandType, index) => (
                <th key={`${brandType.value}-${index}`}>{brandType.label}</th>
              ))}
              <th key='backfill'>Backfill</th>
              <th key='dfp-requests'>DFP Requests</th>
              <th key='dfp'>DFP Displays</th>
              <th key="requests">Requests</th>
              <th key="response">Responses</th>
              <th key="display">Display</th>
              <th key="errors">Errors</th>
              <th key="no-fill-errors">No Fills</th>
              <th key="other-errors">Other Errors</th>
            </tr>
          </thead>
          {console.log(filteredData)}
          {filteredData.length && !loader ? (
            <tbody>
              {filteredData.map((item, index) => {
                console.log(item.backfill_stats.reduce((acc, i) => acc += +i.imprs||0 ,0))
                  const total = item.imprs || 0;
                  const team_stats = item.team_stats || [[], [], []]; // 3 slots
                  const backfill_stats = item.backfill_stats.reduce((acc, i) => acc += +i.imprs||0,0);
                  let dfp_imprs = item.dfp_imprs || 0;
                  let dfp_reqs = item.dfp_reqs || 0;
                  const net_stats = item.net_stats || 0;
                  const ad_partner_stats = item.ad_partner_stats || 0;
                  const net_displays = net_stats.find((i) => i.ad_type === "display")?.count || 0;
                  const net_errors = net_stats.find((i) => i.ad_type === "error")?.count || 0;
                  const net_requests = net_stats.find((i) => i.ad_type === "request")?.count || 0;
                  const net_responses = net_stats.find((i) => i.ad_type === "response")?.count || 0;
                  const net_no_fill_err_count = item.net_no_fill_err_count || 0;
                  const net_other_err_count = item.net_other_err_count || 0;

                  let total_imprs = 0;
                  for (const brand of BrandsTypes) {
                    total_imprs += +team_stats.flat().filter((i) => +i.new_user_type === +brand.value)
                      .reduce((acc, i) => acc + (i.imprs || 0), 0);
                  }

                  const occupancyRate = total
                    ? (((+total_imprs + +net_displays + +ad_partner_stats + +dfp_imprs + +backfill_stats) / +total) * 100).toFixed(2)
                    : "0";

                  const getWithPercent = (val) =>
                    `${formatSpentValue(val)} (${total ? (((+val || 0) / total) * 100).toFixed(1) : "0"}%)`;

                  return (
                    <>
                      {[0, 1, 2].map((slotIndex) => {
                        const slotData = team_stats[slotIndex] || [];

                        return (
                          <tr key={`${index}-${slotIndex}`}>
                            {slotIndex === 0 && (
                              <>
                                <td rowSpan={3}>{item.position}</td>
                                <td rowSpan={3} title={total}>{formatSpentValue(total)}</td>
                              </>
                            )}
                             <td>{slotOptions[slotIndex]}</td>
                            {BrandsTypes.map((brand) => {
                              const brandImps = slotData.find(
                                (i) => +i.new_user_type === +brand.value
                              )?.imprs || 0;

                              return (
                                <td
                                  key={`${brand.value}-${slotIndex}`}
                                  title={`${brand.label}: ${brandImps}`}
                                  className="text-blue-500 cursor-pointer"
                                  onClick={() => {
                                    fetchAdsData({
                                      position: item.position,
                                      new_user_type: brand.value,
                                      slot: slotIndex
                                    });
                                  }}
                                >
                                  {getWithPercent(brandImps)}
                                </td>
                              );
                            })}

                            {slotIndex === 0 && (
                              <>
                                <td rowSpan={3} key="backfill" title={backfill_stats} className="text-pink-500" onClick={() => {
                                    fetchAdsData({
                                      position: item.position,
                                      new_user_type: -1,
                                      slot: 3
                                    });
                                  }}>
                                  {formatSpentValue(backfill_stats)}
                                </td>

                                <td rowSpan={3} key="dfp-reqs" title={dfp_reqs}
                                  className="text-blue-500 cursor-pointer"
                                  onClick={() => fetchDFPInternalData({ position: item.position, ad_type: "request" })}
                                >
                                  {getWithPercent(dfp_reqs)}
                                </td>

                                <td rowSpan={3} key="dfp-imprs" title={dfp_imprs}
                                  className="text-blue-500 cursor-pointer"
                                  onClick={() => fetchDFPInternalData({ position: item.position, ad_type: "display" })}
                                >
                                  {getWithPercent(dfp_imprs)}
                                </td>

                                <td rowSpan={3} key="net-reqs"
                                  className="text-pink-500"
                                  title={net_requests}
                                  onClick={() => getNetadcodeWiseStats({ ad_type: "request", position: item.position })}
                                >
                                  {formatSpentValue(net_requests)}
                                </td>

                                <td rowSpan={3} key="net-resp"
                                  className="text-pink-500"
                                  title={net_responses}
                                  onClick={() => getNetadcodeWiseStats({ ad_type: "response", position: item.position })}
                                >
                                  {formatSpentValue(net_responses)}
                                </td>

                                <td rowSpan={3} key="net-disp"
                                  className="text-pink-500"
                                  title={net_displays}
                                  onClick={() => getNetadcodeWiseStats({ ad_type: "display", position: item.position })}
                                >
                                  {getWithPercent(net_displays)}
                                </td>

                                <td rowSpan={3} key="net-errors"
                                  className="text-pink-500"
                                  title={net_errors}
                                  onClick={() => getNetadcodeWiseStats({ ad_type: "error", position: item.position })}
                                >
                                  {formatSpentValue(net_errors)}
                                </td>

                                <td rowSpan={3} key="net-errors"
                                  className="text-pink-500"
                                  title={net_no_fill_err_count}
                                    onClick={() => getNoFillOtherWiseStats({ error_type: "no_fill", position: item.position })}
                                >
                                  {formatSpentValue(net_no_fill_err_count)}
                                </td>

                                <td rowSpan={3} key="net-errors"
                                  className="text-pink-500"
                                  title={net_other_err_count}
                                  onClick={() => getNoFillOtherWiseStats({ error_type: "other_error", position: item.position })}
                                >
                                  {formatSpentValue(net_other_err_count)}
                                </td>

                                <td rowSpan={3} key="adpartner" title={ad_partner_stats}>
                                  {getWithPercent(ad_partner_stats)}
                                </td>

                                <td rowSpan={3} key="occupancy" title={`Occupancy Rate: ${occupancyRate}%`}>
                                  {occupancyRate}%
                                </td>
                              </>
                            )}

                          </tr>
                        );
                      })}
                    </>
                  );
                })}

              <tr className="font-bold bg-gray-100 sticky bottom-0">
                <td>Totals</td>
                {(() => {
                  // Build totals data structure
                  const totals =  {
                      total: 0,
                      backfill_stats: 0,
                      gam_imprs: 0,
                      gam_reqs: 0,
                      brandImprs: {}, // key = brandType (e.g., team1, team2...)
                      net_requests: 0,
                      net_responses: 0,
                      net_displays: 0,
                      net_errors: 0,
                      ad_partner_stats: 0,
                      dfp_imprs: 0,
                      dfp_reqs: 0,
                      net_no_fill_err_count: 0,
                      net_other_err_count: 0,
                    };

                  // Aggregate data
                  for (const item of filteredData) {
                      totals.total += +item.imprs || 0;
                      totals.backfill_stats += +item.backfill_stats.reduce((acc, i) => acc += +i.imprs||0,0) || 0;
                      totals.net_requests += +item.net_stats.find((i) => i.ad_type === "request")?.count || 0;
                      totals.net_responses += +item.net_stats.find((i) => i.ad_type === "response")?.count || 0;
                      totals.net_displays += +item.net_stats.find((i) => i.ad_type === "display")?.count || 0;
                      totals.net_errors += +item.net_stats.find((i) => i.ad_type === "error")?.count || 0;
                      totals.ad_partner_stats += +item.ad_partner_stats || 0; 
                      totals.dfp_imprs += +item.dfp_imprs || 0;
                      totals.dfp_reqs += +item.dfp_reqs || 0;
                      totals.net_no_fill_err_count += +item.net_no_fill_err_count || 0;
                      totals.net_other_err_count += +item.net_other_err_count || 0;
                      for (const brand of BrandsTypes) {
                        totals.brandImprs[brand.value] =
                          (totals.brandImprs[brand.value] || 0) +
                          (+item.team_stats.flat().filter((i) => +i.new_user_type === +brand.value)
                          .reduce((acc, i) => acc + (+i.imprs || 0), 0));
                      }
                  }

                  // Render total row per language
                  const {
                    total,
                    backfill_stats,
                    net_requests,
                    net_responses,
                    net_displays,
                    net_errors,
                    net_no_fill_err_count,
                    net_other_err_count,
                    ad_partner_stats,
                    brandImprs,
                    dfp_imprs,
                    dfp_reqs,
                  } = totals;

                    const totalImprsSum = Object.values(brandImprs).reduce(
                      (sum, val) => sum + val,
                      0
                    );

                    const occupancyRate = total
                      ? (
                          ((totalImprsSum + net_displays + ad_partner_stats + dfp_imprs + backfill_stats) / total) *
                          100
                        ).toFixed(2)
                      : "0";

                    const getWithPercent = (val) =>
                      `${formatSpentValue(val)} (${
                        total ? (((+val || 0) / total) * 100).toFixed(1) : "0"
                      }%)`;

                    return [
                      <td key={`total`} title={total}>
                        {formatSpentValue(total)}
                      </td>,
                      <td></td>,
                      // Dynamically render brandType columns
                      ...BrandsTypes.map((brand) => {
                        const value = brandImprs[brand.value] || 0;
                        return (
                          <td
                            key={`${brand.value}-total`}
                            title={value}
                          >
                            {getWithPercent(value)}
                          </td>
                        );
                      }),

                      <td key={`backfill`} title={backfill_stats}>
                        {formatSpentValue(backfill_stats)}
                      </td>,

                      <td key={`dfp-reqs`} title={dfp_reqs}>
                        {formatSpentValue(dfp_reqs)}
                      </td>,

                      <td key={`dfp-imprs`} title={dfp_imprs}>
                        {getWithPercent(dfp_imprs)}
                      </td>,

                      <td key={`gam-reqs`} title={net_requests}>
                        {formatSpentValue(+net_requests)}
                      </td>,
                       <td key={`gam-resp`} title={net_responses}>
                       {formatSpentValue(+net_responses)}
                     </td>,
                      <td key={`gam-reqs`} title={net_displays}>
                      {getWithPercent(+net_displays)}
                    </td>,

                      <td key={`gam-imprs`} title={net_errors}>
                        {formatSpentValue(net_errors)}
                      </td>,

                      <td key={`net-no-fill-errors`} title={net_no_fill_err_count}>
                        {formatSpentValue(net_no_fill_err_count)}
                      </td>,

                      <td key={`net-other-errors`} title={net_other_err_count}>
                        {formatSpentValue(net_other_err_count)}
                      </td>,

                      <td key={`adpartner-total`} title={ad_partner_stats}>
                        {getWithPercent(ad_partner_stats)}
                      </td>,
                      <td
                        key={`occupancy`}
                        title={`Occupancy Rate: ${occupancyRate}%`}
                      >
                        {`${occupancyRate}%`}
                      </td>,
                    ];
                  
                })()}
              </tr>
            </tbody>
          ) : !filteredData.length && !loader ? (
            <NoDataFound colspan="17" />
          ) : (
            <TableLoader colspan="17" />
          )}
        </table>
      {adsdata?.length ? (
        <div
          className="inventory-ad-view"
          onClick={() => {
            setAdsData([]);
          }}
        >
          <div className="popupview" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={() => {
                setAdsData([]);
                setShowPreview(false);
                setPreview({});
                setPreviewIndex(-1);
              }}
            >
              <img src={closeSvg} alt="close2" />
            </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Language:{" "}
                <span>
                  {langNames[selectedLanguage] || "All"}
                </span>
              </h5>
              <h5>
                Position: <span>{adsdata[0]?.position}</span>
              </h5>
              <h5>
                Impressions: <span>{formatSpentValue(adsdata.reduce((acc, item) => acc + +item.imprs, 0))}</span>
              </h5>
            </div>
            <div className="over-flow-view flex gap-3 ">
              <div className="w-1/2">
                <table
                  className="table table-bordered table-impress"
                  style={{ width: "100%", margin: "auto" }}
                >
                  <thead className="">
                    <tr>
                      <th>Campaign Name</th>
                      <th>Impressions</th>
                      <th>Creative</th>
                    </tr>
                  </thead>
                  {adsdata.length && !loader ? (
                    <tbody>
                      {adsdata.map((item, index) => (
                        <tr
                          key={index}
                          className={`${
                            previewIndex === index ? "bg-yellow-100" : ""
                          }`}
                        >
                          <td>{item.campaign_name}</td>
                          <td title={item.imprs}>
                            {formatSpentValue(item.imprs)}
                          </td>
                          <td>
                            {
                              <SlIcon
                                name="eye"
                                library="lucide"
                                onClick={() => {
                                  fetchPreview(item);
                                  setPreviewIndex(index);
                                }}
                              />
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : !data.length && !loader ? (
                    <NoDataFound
                      colspan={(5 + BrandsTypes.length + 1) * languages.length}
                    />
                  ) : (
                    <TableLoader
                      colspan={(5 + BrandsTypes.length + 1) * languages.length}
                    />
                  )}
                </table>
              </div>
              <div className="w-1/2">
                <InventoryContext.Provider value={{ preview, setPreview }}>
                  <PreviewFrameEdit showPreview={showPreview} />
                </InventoryContext.Provider>{console.log(preview)}
                {preview?.target_details && Object.keys(preview?.target_details)?.length ? <section className="bg-slate-50 py-4 px-6 rounded-lg mt-2">
                    <h6 className="mb-2">Target</h6>
                    {preview?.actual_target?.lang_ids?.length > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                    {(Array.isArray(preview?.actual_target?.lang_ids) && preview?.actual_target?.lang_ids?.length > 0) && preview?.target_details.lang_ids.map((item, i) => {
                        if (preview?.actual_target?.lang_ids.includes(item))
                            return <span key={i}>{langNames[item]}</span>
                    })}
                    {preview?.target_details?.zone_ids?.length > 0 && <div>
                        {<label className="text-slate-500">Zones : </label>}
                        {preview?.target_details?.zone_ids?.map((item, i) => {
                            return <p key={i}>{item.zone_name}</p>
                        }
                        )}
                    </div>}
                    {!preview?.target_details?.zone_ids?.length ? <>
                    {(Array.isArray(preview?.actual_target?.state_ids) && preview?.actual_target?.state_ids?.length > 0) && (<div>
                        <label className="text-slate-500">States : </label>
                        {preview?.target_details?.state_ids?.filter(stateId => (preview?.target_details?.district_ids?.length === 0 || preview?.target_details?.district_ids?.some(entry => +entry.state_id !== +stateId.state_id))).map((item, i) => {
                            if (preview?.actual_target?.state_ids.includes(item.state_id))
                                return <p>{item.state_name}</p>
                        }
                        )}
                    </div>)}
                    {(!preview?.target_details?.exclude && Array.isArray(preview?.actual_target?.district_ids) && preview?.actual_target?.district_ids?.length > 0) && <div>
                        {<label className="text-slate-500">Districts : </label>}
                        {preview?.target_details?.district_ids?.map((item, i) => {
                            if (preview?.actual_target?.district_ids?.includes(item.dist_id))
                                return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.ex_districts) && preview?.actual_target?.ex_districts?.length > 0) && <div>
                        {<label className="text-slate-500">Excluded Districts : </label>}
                        {preview?.target_details?.district_ids?.map((item, i) => {
                            if (preview?.actual_target?.ex_districts?.includes(item.dist_id))
                                return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.target_details?.constituency_ids) && preview?.target_details?.constituency_ids?.length > 0) && <div>
                        {preview?.target_details?.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                        {preview?.target_details?.constituency_ids?.map((item, i) => {
                            return <p key={i}>{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                        }
                        )}
                    </div>}
                    {(!preview?.target_details?.exclude && Array.isArray(preview?.actual_target?.mandal_ids) && preview?.actual_target?.mandal_ids?.length > 0) && <div>
                        {<label className="text-slate-500">Mandals : </label>}
                        {preview?.target_details?.mandal_ids?.map((item, i) => {
                            if (preview?.actual_target?.mandal_ids?.includes(item.mandal_id))
                                return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.ex_mandals) && preview?.actual_target?.ex_mandals?.length > 0) && <div>
                        {<label className="text-slate-500">Excluded Mandals : </label>}
                        {preview?.target_details?.mandal_ids?.map((item, i) => {
                            if (preview?.actual_target?.ex_mandals?.includes(item.mandal_id))
                                return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.village_ids) && preview?.actual_target?.village_ids?.length > 0) && <div>
                        {<label className="text-slate-500">villages : </label>}
                        {preview?.target_details?.village_ids?.map((item, i) => {
                            if (preview?.actual_target?.village_ids?.includes(item.village_id))
                                return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.ex_villages) && preview?.actual_target?.ex_villages?.length > 0) && <div>
                        {<label className="text-slate-500">Excluded villages : </label>}
                        {preview?.target_details?.village_ids?.map((item, i) => {
                            if (preview?.actual_target?.ex_villages?.includes(item.village_id))
                                return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    </> : null}
                    {(Array.isArray(preview?.target_details?.app_category) && preview?.target_details?.app_category?.length > 0) && <div>
                        {<label className="text-slate-500">App Category : </label>}
                        {preview?.target_details?.app_category?.map((item, i) => (

                            <p key={i}> {appCategoryNames[item]}</p>
                        )
                        )}
                    </div>}
                    {(Array.isArray(preview?.target_details?.minspend) && preview?.target_details?.minspend?.length > 0) && <div>
                        {<label className="text-slate-500">Minimum Spend : </label>}
                        {preview?.target_details?.minspend?.map((item, i) => (

                            <p key={i}>{item}</p>
                        )
                        )}
                    </div>}
                    {preview?.target_details ? <div>
                        {preview?.target_details?.min_age > 0 && <p><label className="text-slate-500">Min Age</label> : {preview?.target_details.min_age}</p>}
                        {preview?.target_details?.max_age > 0 && <p><label className="text-slate-500">Max Age</label> : {preview?.target_details.max_age}</p>}
                        {preview?.target_details?.versions?.android_version && <p><label className="text-slate-500">Android Version</label> : {preview?.target_details?.versions?.android_version || ''}</p>}
                        {preview?.target_details?.versions?.ios_version && <p><label className="text-slate-500">IOS Version</label> : {preview?.target_details?.versions?.ios_version || ''}</p>}
                        {preview?.target_details?.os !== '' && <p><label className="text-slate-500">OS</label> : {osNames[preview?.target_details.os]}</p>}
                        {genderNames[preview?.target_details?.gender] !== null && <p><label className="text-slate-500">Gender</label> : {genderNames[preview?.target_details.gender]} </p>}
                    </div> : null}
                </section> : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {netPosView ? (
        <div
          className="inventory-ad-view"
          onClick={() => {
            setNetPosView(null);
            setErrorCodewiseStats(null);
            setPreviewIndex(-1);
          }}
        >
          <div class="popupview" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={() => {
              setNetPosView(null);
              setErrorCodewiseStats(null);
              setPreviewIndex(-1);
            }}>
              <img src={closeSvg} alt="close2" />
            </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Language:{" "}
                <span className="capitalize">{langNames[netPosView.lang_id] || "All"}</span>
              </h5>
              <h5>
                Position: <span>{netPosView.position}</span>
              </h5>
              <h5>
                Ad Type: <span>{netPosView.ad_type}</span>
              </h5>
              <h5>
                Count: <span>{formatSpentValue(netPosView?.data?.reduce((acc, item) => acc + +item.count, 0))}</span>
              </h5>
            </div>
            <div className="d-flex gap-2">
            <div className="over-flow-view">
              <div className="ad-codes">
                <table className="table table-bordered table-impress">
                  <thead>
                    <tr>
                      <th>Ad Code</th>
                      <th>Count</th>
                      {netPosView.ad_type === 'error' ?<th>View</th> : null}
                    </tr>
                  </thead>
                  <tbody>
                    {netPosView?.data?.map((item, index) => (
                      <tr key={index}
                      className={`${
                        previewIndex === index ? "bg-yellow-100" : ""
                      }`}>
                        <td>{item.ad_code}</td>
                        <td>{formatSpentValue(item.count)}</td>
                        {netPosView.ad_type === 'error' ? <td>
                            {
                              <SlIcon
                                name="eye"
                                library="lucide"
                                onClick={() => {
                                  fetchErrorCodewiseStats({ad_code: item.ad_code, position: netPosView.position});
                                  setPreviewIndex(index);
                                }}
                              />
                            }
                          </td> : null}
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>

            {
                  errorCodewiseStats ? (
                    <div className="overflow-y-auto max-h-[300px]">
                      <table className="table table-bordered table-impress">
                        <thead>
                          <tr>
                            <th>Error Code</th>
                            <th>Count</th>
                          </tr>
                      </thead>
                      <tbody>
                        {errorCodewiseStats.map((item, index) => (
                          <tr key={index}>
                            <td>{item.description}</td>
                            <td>{formatSpentValue(item.count)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  ) : null
                }
              </div>
          </div>
        </div>
      ) : null}

      {dfpInternalData?.length ? (
        <div className="inventory-ad-view"
        onClick={() => {
          setDFPInternalData([]);
        }}>
          <div className="popupview" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={() => {
                setDFPInternalData([]);
              }}
            >
            <img src={closeSvg} alt="close2" />
          </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Position: <span>{dfpInternalData[0]?.position}</span>
              </h5>
              <h5>
                {dfpInternalData[0]?.ad_type === "request" ? "Requests" : "Displays"}: <span>{formatSpentValue(dfpInternalData.reduce((acc, item) => acc + +item.imprs, 0))}</span>
              </h5>
            </div>
            <div className="d-flex gap-2">
              <div className="over-flow-view">
                <table className="table table-bordered table-impress">
                  <thead>
                    <tr>
                      <th>Ad Code</th>
                      <th>Impressions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dfpInternalData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.ad_code}</td>
                        <td>{formatSpentValue(item.imprs)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Inventory;
